export const languageStringsSubscriptions = {
  title: "Předplatné",
  successPayment: "Platba proběhla v pořádku.",
  successPaymentDescription: "Během okamžiku se vám kredity objeví na účtě.",
  wantToChangeSubscription: "Opravdu si přejete změnit předplatné ",
  changeFrom: "ze ",
  changeTo: " na ",
  subTitle: "Vaše předplatné",
  portableCreditsDescription:
    "Tyto kredity nemají expiraci. Použijí se pokud jste přesáhli výši měsíčního kreditu.",
  tarifs: {
    title: "Tarify",
    monthly: "Měsíčně",
    yearly: "Ročně",
    monthlyPeriod: "měsíční",
    yearlyPeriod: "roční",
    freeMonths: "2 měsíce zdarma",
    viewsPerMonth: "počet zobrazení za měsíc",
    trial: "zkušební verze - bez omezení",
    creditsRefresh: "Obnova kreditů proběhne: ",
    creditsExpire: "Kredity expirují: ",
    subbscription: "Předplatné",
    trialVersion: "zkušební verze",
    trialVersionExpires: "Zkušební verze vyprší",
    cancelSubscription: "Zrušit obnovu předplatného",
    nextPayment: "Další platba bude automaticky provedena",
    unlimitedVersion: "Je aktivní neomezená verze aplikace",
    choseSubscription: "Vybrat tarif",
    to: "Do",
    monthlyViews: "zobrazení stránek měsíčně",
    pricesAreFinal: "Uvedené ceny jsou finální.",
    moreViews: "Mají vaše stránky ještě více zobrazení měsíčně?",
    contactUsForCustom: "Kontaktujte nás pro tarif na míru.",
    notificationsWithStatistics: "Notifikace se statistikami návštěvnosti",
    notificationsWithLastOrdersAndRegistrations:
      "Notifikace posledních objednávek a registrací",
    notificationPersonalization: "Personalizace notifikací",
    zboziAndHeureka: "Notifikace recenzí z Heureky a Zboží.cz",
    googleRecenze: "Propojení s Google recenze",
    trustPilot: "Propojení s Trustpilot",
    logoCancel: "Odstranění loga",
    customBranding: "Custom branding",
    unlimitedNotifications: "Neomezeně notifikací",
    unlimitedWebsites: "Neomezený počet webů",
    onlyOneWebsite: "(pouze 1 web)",
    activateFreeTrial: "Aktivovat 14 dní zdarma",
    mostFavorite: "Nejoblíbenější",
    selected: "Vybráno",
    notAvailable: "Nedostupný",
    "LITE": {
      title: "LITE",
      priceYearly: "$50",
      priceMonthly: "$5",
    },
    "MEDIUM": {
      title: "MEDIUM",
      priceYearly: "$200",
      priceMonthly: "$20",
    },
    "UNLIMITED": {
      title: "UNLIMITED",
      priceYearly: "$350",
      priceMonthly: "$35",
    },
    lite: {
      title: "LITE",
      priceYearly: "39 Kč",
      priceMonthly: "47 Kč",
    },
    start: {
      title: "START",
      priceYearly: "247 Kč",
      priceMonthly: "297 Kč",
    },
    standard: {
      title: "STANDARD",
      priceYearly: "457 Kč",
      priceMonthly: "547 Kč",
    },
    premium: {
      title: "PREMIUM",
      priceYearly: "833 Kč",
      priceMonthly: "997 Kč",
    },
  },
};
